var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lensman-detail-box"},[_c('member-detail-banner'),_c('member-detail-info',{attrs:{"service-router":"lensmanService"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }